import { State } from "./state";
import { Request } from "../network/request"
import notify from '../helpers/toast-notifications'
import i18n from '../i18n'
import axios from "axios";

export default class authStore {
    mealData = []
    studentCard = {
        id: '',
        firstName: '',
        lastName: '',
        serial: '',
        daily_limit: '',
        balance: '',
        buffet_note: '',
        ordered_meals: '',
        meals: [],
    }
    mealsTable = {
        tableHeaders: [
            'image',
            'name',
            'description',
            'status',
            'price',
            'settings'

        ],
        tableData: [],
        loading: false,
        tableMeta: {
            total: 10,
            page: 1,
        },
    }
    mealsOrderTable = {
        tableHeaders: [
            'image',
            'id',
            'name',
            'price',
            'total',
            'display',

        ],
        tableData: [],
        loading: false,
    }
    mealsStudentsTable = {
        tableHeaders: [
            'image',
            'id',
            'name',
            'description',
            'status',
            'dayes Avilable in',
            'price',
            'settings'

        ],
        tableData: [],
        loading: false,
        tableMeta: {
            total: 10,
            page: 1,
        },
    }



    mealState = new State()
    storeMealState = new State()
    editMealState = new State()
    updateImage = new State()
    deleteMealState = new State()

    orderMealsState = new State()
    getMealsNameState = new State()

    mealStudentCreateState = new State()

    studentBuffetCard = new State()

    buffetbuyState = new State()
    buffetreturnState = new State()





    geatAllMeal(payload) {
        let token = localStorage.getItem('access_token')
        let request = new Request('get', `catalog/product`, null, payload, token)
        this.mealState.trigger(async () => {
            return await (await request.send());
        },
            {
                onSuccess: (value) => {
                    this.setMealData(value)
                    console.log(value)
                },
                onError: (error) => { console.log(error) }
            });
    }
    getOrderdMeals(params) {
        let token = localStorage.getItem('access_token')
        let request = new Request('get', `/meals-report`, null, params, token)
        this.orderMealsState.trigger(async () => {
            return await (await request.send());
        },
            {
                onSuccess: (value) => {
                    this.mealsOrderTable.tableData = value
                },
                onError: (error) => { console.log(error) }
            });

    }
    getMealsName(payload) {
        let token = localStorage.getItem('access_token')
        let request = new Request('get', `/catalog/product?name=${payload}`, null, null, token)

        this.getMealsNameState.trigger(async () => {
            return await (await request.send());
        },
            {
                onSuccess: (value) => {
                    this.mealData = value.meals
                },
                onError: (error) => { console.log(error) }
            });

    }
    async StoreMeal(payload) {
        try {
            let form = new FormData();
            for (let key in payload) {

                if (payload[key]) {

                    form.append(`${key}`, payload[key])


                }
            }
            let res = await axios.post(`/catalog/product`, form);
            this.geatAllMeal(1);
            notify(
                i18n.t('add success'),
                { timeout: 4000, rtl: true },
                "success"
            );

        } catch (error) {

        }
    }

    async editMeal(payload, payload2) {
        try {


            let res = await axios.post(`/catalog/product/${payload2}`, payload);

            this.geatAllMeal(1);
            notify(
                i18n.t('edit success'),
                { timeout: 4000, rtl: true },
                "success"
            );

        } catch (error) {

        }
    }
    deleteMeal(payload) {
        let token = localStorage.getItem('access_token')
        let request = new Request('delete', `catalog/product/${payload}`, null, null, token)
        this.deleteMealState.trigger(async () => {
            return await (await request.send());
        },
            {
                onSuccess: (value) => {
                    this.geatAllMeal(1)
                },
                onError: (error) => { console.log(error) }
            });
    }
    createStudentMeal(payload) {
        let token = localStorage.getItem('access_token')
        let request = new Request('post', `student_meal`, payload, null, token)
        this.mealStudentCreateState.trigger(async () => {
            return await (await request.send());
        },
            {
                onSuccess: (value) => {

                },
                onError: (error) => { console.log(error) }
            });
    }

    getStudentBuffetCard(payload) {
        let token = localStorage.getItem('access_token')
        let request = new Request('get', `/buffet-card/${payload}`, null, null, token)
        this.studentBuffetCard.trigger(async () => {
            return await (await request.send());
        },
            {
                onSuccess: (value) => {
                    console.log(value.data)
                    this.setCardData(value.data)

                },
                onError: (error) => { console.log(error) }
            });
    }
    storeBulkBuffetOperation(payload) {
        let token = localStorage.getItem('access_token');
        let request = new Request('post', `/billing/invoice/list`, payload, null, token);

        // You MUST return a Promise so that `await` correctly pauses the Vue component
        return new Promise((resolve, reject) => {
            this.buffetbuyState.trigger(async () => {
                return await (await request.send());
            },
                {
                    onSuccess: (value) => {
                        // Just resolve the value back to Vue, no notify needed here!
                        resolve(value);
                    },
                    onError: (error) => {
                        console.error("Backend Error Object:", error);

                        // Extract a useful message or the whole response
                        const extractedError = error.response ? error.response.data : error;
                        reject(extractedError);
                    }

                });
        });
    }


    storeBuffetOperation(payload) {
        let token = localStorage.getItem('access_token')
        let request = new Request('post', `/billing/invoice`, payload, null, token)
        return new Promise((resolve, reject) => {
            this.buffetbuyState.trigger(async () => {
                return await (await request.send());
            },
                {
                    onSuccess: (value) => {
                        resolve(value);
                    },
                    onError: (error) => {
                        reject(error);
                    }
                });
        });
    }

    restoreBuffetOperation(payload) {
        let token = localStorage.getItem('access_token')
        let request = new Request('post', `/billing/invoice`, payload, null, token)
        this.buffetreturnState.trigger(async () => {
            return await (await request.send());
        },
            {
                onSuccess: (value) => {
                    notify(
                        i18n.t('add success'),
                        { timeout: 4000, rtl: true },
                        "success"
                    );
                },
                onError: (error) => {
                    console.log(error)
                }
            });
    }
    ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    setMealData(data) {
        this.mealsTable.tableData = data.data
        this.mealsTable.tableMeta.total = data.meta.total
        this.mealsTable.tableMeta.page = data.meta.current_page

    }
    async setCardData(data) {
        this.studentCard.serial = data.serial
        this.studentCard.balance = data.balance
        this.studentCard.daily_limit = data.daily_limit
        this.studentCard.buffet_note = data.buffet_note
        this.studentCard.ordered_meals = data.ordered_meals
        this.studentCard.id = data.student_id
        this.studentCard.meals = await data.meals.map((el) => ({
            ...el
        }));
        console.log(this.studentCard.meals);
    }

}
export const meal = new authStore();